<template>
  <div class="container">
    <div class="btn-goto" :style="{background:'url('+backgroundImg+') no-repeat',backgroundSize:'100% 100%'} ">
      <div class="btn" @click="h5Click()">前往小程序</div>
    </div>
  </div>
</template>

<script>
import {validateCode, getMiniScheme, equitiesTypeList, configLatest} from "@/api/ycMini";

export default {
  name: "index",
  data() {
    return {
      isWx: false, //在微信浏览器还是网页浏览器
      codeType: "",
      goLink:"",
      defalutImg:'',
      backgroundImg:''
    }
  },
  methods: {
    // getSystemEnvironment() {
    //   var ua = window.navigator.userAgent.toLowerCase();
    //   if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    //     this.isWx = true;
    //   } else {
    //     this.isWx = false;
    //   }
    // },
    // 验证防伪码是否正确
    async validateCodeFlag() {
      try{
        let res = await validateCode({code: this.$route.query.c})
        let msgObj = null;
        if(res && res.code == 200){
          msgObj = JSON.parse(res.msg);
          if (msgObj.code == 0) {
            //验证通过
            this.getBgImgUrl()
          }else{
            this.backgroundImg = this.defalutImg;
            this.$message.warning(msgObj.msg);
          }
        }else{
          this.backgroundImg = this.defalutImg;
        }
      }catch (e){
        this.backgroundImg = this.defalutImg;
      }
    },
    //获取小程序scheme地址
    async getMiniUrl(){
      let query = this.codeType == '1'?'zyys':this.codeType == '2'?'xyzh':''
      let params = {
        path: "pages/home/index",
        query: 'tabId='+query,
        env_version: 'release',//release,develop,trial
      }
      let res = await getMiniScheme({jump_wxa:params});
      this.goLink = res.openlink
    },
    //获取验证成功后的背景图片地址
    async getBgImgUrl() {
      let res = await equitiesTypeList();
      //过滤出equitiesCode == codeType的数据的图片地址
      if(res && res.data){
        let imgUrl = res.data.find(item => item.equitiesCode == this.codeType)?res.data.find(item => item.equitiesCode == this.codeType).equitiesH5Url:'';
        this.backgroundImg = imgUrl;
      }
    },
    //获取验证错误展示的默认背景图片
    async getConfigInfo(){
      let res = await configLatest({type:4});
      this.defalutImg = res.data.contentPhotoUrl;
    },
    //跳转到小程序
    h5Click(){
      location.href = this.goLink
    }
  },
  mounted() {
    this.codeType = this.$route.query.t || '';
    this.getConfigInfo()
    this.getMiniUrl()
    if(this.$route.query.c && this.$route.query.t){
      //验证防伪码是否正确
      this.validateCodeFlag()
    }
  },
}
</script>
<style scoped lang="scss">
.container{
  * {
    margin: 0;
    padding: 0;
  }

  .btn-goto {
    width: 100vw;
    height: 100vh;
    .btn{
      width: 160px;
      height: 52px;
      text-align: center;
      line-height: 52px;
      background: linear-gradient( 180deg, #9FDCFF 0%, #135FD4 100%);
      box-shadow: 0 4px 24px 0 rgba(119,166,234,0.5);
      border-radius: 26px;
      font-weight: 600;
      font-size: 18px;
      color: #FFFFFF;
      position: fixed;
      bottom: 8%;
      left: calc(50% - 80px);
    }
  }
  //.isBgTrueyys{
  //  background: url('../../assets/images/syyy.png');
  //  background-size: 100% 100%;
  //}
  //.isBgTruexyzh{
  //  background: url('../../assets/images/bkYc.png');
  //  background-size: 100% 100%;
  //}
}
</style>
